/*
 * Which clip/music copies on this device are still used (choice ก): copies are deleted when their video work is
 * deleted, and "พื้นที่วิดีโอในเครื่อง" clears copies that no work uses any more.
 * Only the 1080p copies made by the app are ever deleted — never the original files in the photo library.
 *
 * Pure: the caller collects the projects (src/ui/videoStore.ts). A copy counts as used when ANY of these names it:
 *   - a video work of mine on the server
 *   - the work open on screen, including every undo/redo step (undo must be able to bring a deleted clip back)
 * When any of them cannot be read, nothing is deleted (an incomplete list would delete copies still in use).
 */

/** media keys named in a design JSON (its `video` clips and music); a JSON that is not a video gives none */
export function mediaKeysIn(json: string): string[] {
  const keys = new Set<string>();
  for (const m of json.matchAll(/"media"\s*:\s*"([A-Za-z0-9_-]{6,64})"/g)) keys.add(m[1]);
  return [...keys];
}

/** stored copies that no work uses */
export function unusedMedia<T extends { key: string }>(stored: T[], used: Set<string>): T[] {
  return stored.filter(s => !used.has(s.key));
}

/** "135 MB" / "0.4 MB" */
export function sizeText(bytes: number): string {
  const mb = bytes / 1048576;
  return `${mb >= 10 ? Math.round(mb) : mb.toFixed(1)} MB`;
}
